import ScreenPermissionCreate from 'screens/Permission/Create';
import ScreenPermissionUpdate from 'screens/Permission/Update';
import ScreenPermissionDetails from 'screens/Permission/Details';
import ScreenPermissionList from 'screens/Permission/List';
import { PERMISSION } from 'routes/paths';

const permissionsRoutes = [
  {
    path: PERMISSION.CREATE,
    name: 'PermissionCreate',
    component: ScreenPermissionCreate,
    loginRequired: true,
  },
  {
    path: PERMISSION.UPDATE,
    name: 'PermissionUpdate',
    component: ScreenPermissionUpdate,
    loginRequired: true,
  },
  {
    path: PERMISSION.DETAILS,
    name: 'PermissionDetails',
    component: ScreenPermissionDetails,
    loginRequired: true,
  },
  {
    path: PERMISSION.LIST,
    name: 'PermissionList',
    component: ScreenPermissionList,
    loginRequired: true,
  },
];

export default permissionsRoutes;
